import React, { createContext, useState, useEffect, ReactNode, useContext } from 'react';
import axios from 'axios';

interface PublicAuthContextType {
    clientToken: string | null;
    client: any | null;
    loginClient: (token: string, clientData: any) => void;
    logoutClient: () => void;
    isAuthenticated: boolean;
    loading: boolean;
}

const PublicAuthContext = createContext<PublicAuthContextType | null>(null);

export const PublicAuthProvider = ({ children }: { children: ReactNode }) => {
    const [clientToken, setClientToken] = useState<string | null>(null);
    const [client, setClient] = useState<any>(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const storedToken = localStorage.getItem('client_token');
        const storedClient = localStorage.getItem('client_data');

        if (storedToken && storedClient) {
            setClientToken(storedToken);
            setClient(JSON.parse(storedClient));
        }
        setLoading(false);
    }, []);

    const loginClient = (token: string, clientData: any) => {
        setClientToken(token);
        setClient(clientData);
        localStorage.setItem('client_token', token);
        localStorage.setItem('client_data', JSON.stringify(clientData));
    };

    const logoutClient = () => {
        setClientToken(null);
        setClient(null);
        localStorage.removeItem('client_token');
        localStorage.removeItem('client_data');
    };

    return (
        <PublicAuthContext.Provider value={{
            clientToken,
            client,
            loginClient,
            logoutClient,
            isAuthenticated: !!clientToken,
            loading
        }}>
            {children}
        </PublicAuthContext.Provider>
    );
};

export const usePublicAuth = () => {
    const context = useContext(PublicAuthContext);
    if (!context) {
        throw new Error('usePublicAuth must be used within a PublicAuthProvider');
    }
    return context;
};
